module.exports = __webpack_public_path__ + "16daa2f9f7a116ae1df9f86977e233fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-basic-2.png
// module id = 958
// module chunks = 0